import { render, staticRenderFns } from "./BusinessPlaceAdd.vue?vue&type=template&id=7522f0fa&scoped=true&"
import script from "./BusinessPlaceAdd.vue?vue&type=script&lang=js&"
export * from "./BusinessPlaceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522f0fa",
  null
  
)

export default component.exports